import { render, staticRenderFns } from "./babyBarn.vue?vue&type=template&id=5da2fa1b&scoped=true"
import script from "./babyBarn.vue?vue&type=script&lang=js"
export * from "./babyBarn.vue?vue&type=script&lang=js"
import style0 from "./babyBarn.vue?vue&type=style&index=0&id=5da2fa1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da2fa1b",
  null
  
)

export default component.exports